var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"af-jobview-widget af-jobview-widget-mobile"},[_c('div',{staticClass:"af-jobview-actions afu-px-5 afu-py-7 md:afu-p-8 afu-bg-white"},[_c('JobViewActionsMobile'),_c('ShareJobMobile')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }